import {
  Communicator,
  createCommunicatorHook,
} from "../../Helpers/Communicator";

export const callCommunicator = new Communicator();

export const useCallCommunicator = createCommunicatorHook(callCommunicator);
